
const comFooterCarousel = (() => {
  const jsFooter = (document.getElementById("jsFooter") != null);
  if (jsFooter) {


    let sW = window.innerWidth;

    const footer = document.getElementById('jsFooter');
    const carouselWrap = footer.querySelector('.js-carousel-wrap');
    const jsSwiper = carouselWrap.querySelector('.js-swiper');
    const swiperPagination = carouselWrap.querySelector('.js-swiper-pagination');
    const swiperBtnPrev = carouselWrap.querySelector('.js-swiper-btn-prev');
    const swiperBtnNext = carouselWrap.querySelector('.js-swiper-btn-next');

    let slidesPerView;
    let spaceBetween;

    if (sW > 750) {
      slidesPerView = 2.0
      spaceBetween = 80
    } else {
      slidesPerView = 1.2
      spaceBetween = 80
    }

    const swiper = new Swiper(jsSwiper, {
      loop: true,
      centeredSlides: true,
      slidesPerView: slidesPerView,
      spaceBetween: spaceBetween,
      speed: 800,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      pagination: {
        el: swiperPagination,
        clickable: true,
      },
      navigation: {
        nextEl: swiperBtnNext,
        prevEl: swiperBtnPrev
      }
    });





  }
})();
export default comFooterCarousel;